module.exports = __webpack_public_path__ + "static/media/for_schools.2438aa8e.png";